import React, { PureComponent } from 'react';

class RadioButtonLineOfCredits extends PureComponent {

    render() {

      const { GET_LINEA_PRESTAMO, Cuenta, guardarCampoCuenta } = this.props;
      const radioPrestamos = GET_LINEA_PRESTAMO.map((prestamo, index) => {

        let estaSeleccionado = (prestamo.Id == Cuenta.LineaPrestamoVisaId);

        return (
        <div className="col-xs-2" key={"prestamo-" + index} >
            <div className="container-radio radio-margin">
                <input type="radio" name="prestamo" value={prestamo.Id} id={"prestamo-radio-" + index}
                    checked={estaSeleccionado} data-codigo={prestamo.Codigo}
                    onChange={(event) => {
                        let codigo = event.target.dataset.codigo;
                        guardarCampoCuenta(event.target.value, "LineaPrestamoVisaId", codigo)
                    }} />
                <label className="lbl-radio label-secondary" htmlFor={"prestamo-radio-" + index}>{prestamo.Descripcion}</label>
            </div>
        </div>
        );

      });

      return (
      <div className="bottom-separator-xs">
       <div className="row">
          <div className="col-xs-12">
             <label className="label-primary">Línea de préstamos</label>
             <label className="label-secondary">(opcional) </label>
          </div>
          <div className="col-xs-12">
            {radioPrestamos}
          </div>
       </div>
      </div>
      );
    }
}

export default RadioButtonLineOfCredits;